import React from 'react';

interface GButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'gold';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  loading?: boolean;
  fullWidth?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  children: React.ReactNode;
  isGradient?: boolean;
  textStyle?: string;
}

const variants = {
    primary: 'bg-gradient-to-r from-[#4DBDFF] to-[#0086D3] justify-center items-center flex',
    secondary: 'bg-gray-600 hover:bg-gray-700 text-white',
    outline: 'border border-blue-600 text-blue-600 hover:bg-blue-50',
    ghost: 'text-blue-600 hover:bg-blue-50',
    gold: 'bg-gradient-to-r from-[#EF9E3F] to-[#FBD765] justify-center items-center flex',
}


const GButton: React.FC<GButtonProps> = ({
  variant = 'primary',
  size = 'md',
  loading = false,
  fullWidth = false,
  leftIcon,
  rightIcon,
  children,
  isGradient = false,
  className = '',
  disabled,
  textStyle = '',
  ...props
}) => {

  

  return (
    <button
      className={`${variants[variant]} rounded-[14px] transition-all duration-300 ease-out hover:shadow-[0_4px_25px_rgba(0,134,211,0.35)] hover:scale-[1.02] active:scale-[0.97] disabled:hover:scale-100 disabled:active:scale-100 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:shadow-none ${className}`}
      disabled={disabled || loading}
      {...props}
    >
        <p className={`text-white text-[15px] md:text-[18px] font-semibold tracking-wide ${textStyle}`}>{children}</p>
    </button>
  );
};

export default GButton;